/** Maps to FluentUI type of of MessageBar
 * @see https://developer.microsoft.com/en-us/fluentui#/controls/web/messagebar#MessageBarType
 */
/* eslint-disable-next-line no-restricted-syntax
-- TODO: Suppression added when adding rule to recommend avoiding enums. Enums generate a lot of bundle size bloat, please consider moving to an alternate pattern. */
export var BannerType;
(function (BannerType) {
    /** Info styled MessageBar */
    BannerType[BannerType["info"] = 0] = "info";
    /** Error styled MessageBar */
    BannerType[BannerType["error"] = 1] = "error";
    /** Blocked styled MessageBar */
    BannerType[BannerType["blocked"] = 2] = "blocked";
    /** SevereWarning styled MessageBar */
    BannerType[BannerType["severeWarning"] = 3] = "severeWarning";
    /** Success styled MessageBar */
    BannerType[BannerType["success"] = 4] = "success";
    /** Warning styled MessageBar */
    BannerType[BannerType["warning"] = 5] = "warning";
})(BannerType || (BannerType = {}));
//# sourceMappingURL=BannerInfo.js.map